// Imports for external libraries go here.
import React from 'react';
import clsx from 'clsx';
// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { StyledDropdown } from './Dropdown.styles';
import { DropdownProps } from './Dropdown.types';
import { Text, size, tags } from '@marriott/mi-ui-library';

// Use named rather than default exports.
export const Dropdown = React.forwardRef<HTMLSelectElement, DropdownProps>(
  ({ id, label, name, options, errorMessage, handleChange, value, placeholder, className }, ref) => {
    return (
      <StyledDropdown className={clsx(className)} data-component-name="m-legal-Dropdown" data-testid="legal-Dropdown">
        <div className="m-input-field" data-testid="dropdown-wrapper">
          {label && (
            <label htmlFor={id} className={clsx({ 'error-text': Boolean(errorMessage) })}>
              {label}
            </label>
          )}
          <select
            name={name}
            onChange={e => handleChange?.(e.target.value)}
            className={clsx({ 'is-error': Boolean(errorMessage) })}
            value={value}
            id={id}
            ref={ref}
          >
            {placeholder && (
              <option key="placeholder" hidden>
                {placeholder}
              </option>
            )}
            {options?.map(({ label, value }) => (
              <option key={`${label}-${value}`} value={value}>
                {label}
              </option>
            ))}
          </select>
          {errorMessage && (
            <Text fontSize={size.small} element={tags.span} copyText={errorMessage} customClass="error-text" />
          )}
        </div>
      </StyledDropdown>
    );
  }
);
